import { graphql } from 'react-relay';

export const detailFilterSelectionInfoFragment = graphql`
    fragment DetailFilterSelectionInfo_selectionInfo on DetailFilterSelectionInfo {
        resetText
        resultTextSingular
        resultTextPlural
    }
`;
